// @core/api/endpoints/webhook/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { CreateEndpoint } from './create_endpoint';
import { CreateWebhookPolicy } from './create_webhook_policy';
import { DeleteEndpoint } from './delete_endpoint';
import { DeleteWebhookPolicy } from './delete_webhook_policy';
import { DisableEndpoint } from './disable_endpoint';
import { EnableEndpoint } from './enable_endpoint';
import { GetDelivery } from './get_delivery';
import { GetEndpoint } from './get_endpoint';
import { GetEndpointStats } from './get_endpoint_stats';
import { GetWebhookPolicy } from './get_webhook_policy';
import { GetWebhookPolicyByEntity } from './get_webhook_policy_by_entity';
import { GetWebhookStats } from './get_webhook_stats';
import { ListDeliveries } from './list_deliveries';
import { ListEndpoints } from './list_endpoints';
import { ListEventTypes } from './list_event_types';
import { ListWebhookPolicies } from './list_webhook_policies';
import { PublishEvent } from './publish_event';
import { PublishEvents } from './publish_events';
import { ResolveWebhookContext } from './resolve_webhook_context';
import { RetryDelivery } from './retry_delivery';
import { RotateSecret } from './rotate_secret';
import { TestEndpoint } from './test_endpoint';
import { UpdateEndpoint } from './update_endpoint';
import { UpdateWebhookPolicy } from './update_webhook_policy';

// Re-export individual endpoints
export {
  CreateEndpoint,
  CreateWebhookPolicy,
  DeleteEndpoint,
  DeleteWebhookPolicy,
  DisableEndpoint,
  EnableEndpoint,
  GetDelivery,
  GetEndpoint,
  GetEndpointStats,
  GetWebhookPolicy,
  GetWebhookPolicyByEntity,
  GetWebhookStats,
  ListDeliveries,
  ListEndpoints,
  ListEventTypes,
  ListWebhookPolicies,
  PublishEvent,
  PublishEvents,
  ResolveWebhookContext,
  RetryDelivery,
  RotateSecret,
  TestEndpoint,
  UpdateEndpoint,
  UpdateWebhookPolicy,
};

// Namespace export for convenient usage
export const webhookApi = {
  CreateEndpoint,
  CreateWebhookPolicy,
  DeleteEndpoint,
  DeleteWebhookPolicy,
  DisableEndpoint,
  EnableEndpoint,
  GetDelivery,
  GetEndpoint,
  GetEndpointStats,
  GetWebhookPolicy,
  GetWebhookPolicyByEntity,
  GetWebhookStats,
  ListDeliveries,
  ListEndpoints,
  ListEventTypes,
  ListWebhookPolicies,
  PublishEvent,
  PublishEvents,
  ResolveWebhookContext,
  RetryDelivery,
  RotateSecret,
  TestEndpoint,
  UpdateEndpoint,
  UpdateWebhookPolicy,
};
